// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__optional--XZVu2 {\n  font-weight: 400;\n  font-size: 12px;\n  color: var(--gray-400);\n  margin-left: 4px;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/InsuranceBillingOnboarding/components/OptLabel/s.module.less"],"names":[],"mappings":"AACA;EACI,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AAAJ","sourcesContent":["// 可选字段标签（原型 .opt）\n.optional {\n    font-weight: 400;\n    font-size: 12px;\n    color: var(--gray-400);\n    margin-left: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"optional": "s-module__optional--XZVu2"
};
export default ___CSS_LOADER_EXPORT___;
